(function () {
  function initCarousel(root) {
    var scroller = root.querySelector('[data-hero-carousel]');
    var dotsWrap = root.querySelector('[data-hero-dots]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    if (!scroller || !dotsWrap) return;

    var slides = Array.prototype.slice.call(scroller.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;

    var index = 0;

    function goTo(i, behavior) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      scroller.scrollTo({ left: slides[index].offsetLeft, behavior: behavior || 'smooth' });
      sync();
    }

    function sync() {
      index = Math.round(scroller.scrollLeft / Math.max(scroller.clientWidth, 1));
      index = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    dotsWrap.innerHTML = '';
    var dots = slides.map(function (_, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'playlist-hero__dot' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
      dotsWrap.appendChild(btn);
      return btn;
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index + 1);
      });
    }

    scroller.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function boot() {
    document.querySelectorAll('.playlist-hero').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
